import styled from 'styled-components';

import { GetActiveOrganizationsQuery, GetUserQuery } from 'data/__generated__';

import { DetailFormSelect, DetailLink } from 'components/DetailsView';

import { DefaultTruckColumnSelector } from './DefaultTruckColumnSelector';

type Props = {
    user: NonNullable<GetUserQuery['userFromAdmin']>;
    organizations: GetActiveOrganizationsQuery['activeOrganizations'];
};

const USER_GROUP_OPTIONS_BY_ORG: Record<string, { label: string; value: string }[]> = {
    // MWM test
    RQRwTBvQMhwd92XsD: [{ label: 'MWM in office employees', value: 'd3817dc2-84a0-4293-b0d3-016146f0ecbd' }],
};

export const OrganizationGroupsSection = ({ user, organizations }: Props) => {
    const { organization, userGroupIds } = user;

    const organizationOptions = organizations.map(({ _id, name }) => ({ value: _id, label: name }));
    const groupOptions = organization?._id ? USER_GROUP_OPTIONS_BY_ORG[organization._id] : undefined;

    return (
        <Container>
            <DetailFormSelect<string | null>
                label="Organisation"
                placeholder="Sélectionner une organisation"
                defaultValue={organization?._id || null}
                name="organizationId"
                options={organizationOptions}
                isClearable
            />
            {organization?._id ? (
                <DetailLink
                    path="organization"
                    name={`Page de l'organisation ${organization.name}`}
                    value={organization._id}
                />
            ) : null}
            {organization?._id && groupOptions ? (
                <DetailFormSelect<string>
                    isMulti
                    label="Groupes"
                    placeholder="Sélectionnez un ou plusieurs groupes"
                    defaultValue={userGroupIds}
                    isClearable
                    name="userGroupIds"
                    options={groupOptions}
                />
            ) : null}
            <DefaultTruckColumnSelector />
        </Container>
    );
};

const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 15px;
`;
